import { ContractIAImportState, ContractIAImportUnloadState } from '../../states/Contract.IAImport.States';
import * as actions from '../../actions/Contract.IAImport.Actions';

export default function ContractIAImportCreateReducer(
  state: ContractIAImportState | undefined,
  action: any
): ContractIAImportState {
  const currentState = state ?? ContractIAImportUnloadState;
  switch (action.type) {
    case actions.CONTRACT_IAIMPORT_CREATE_REQUEST:
      return {
        ...currentState,
        isCreatingProcess: true,
        successCreatingProcess: undefined,
        failOnCreatingProcess: false,
        error: undefined,
      };
    case actions.CONTRACT_IAIMPORT_CREATE_SUCCESS:
      return {
        ...currentState,
        isCreatingProcess: false,
        successCreatingProcess: true,
        failOnCreatingProcess: false,
        // El último proceso queda actualizado al creado
        lastProcess: action.process,
      };
    case actions.CONTRACT_IAIMPORT_CREATE_FAILURE:
      return {
        ...currentState,
        isCreatingProcess: false,
        successCreatingProcess: false,
        failOnCreatingProcess: true,
        error: action.error,
      };
    default:
      return currentState;
  }
}
